<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="秒杀名称：" prop="name">
            <el-input style="width: 424px;" v-model="ruleForm.name" placeholder="请输入活动名称"></el-input>
          </el-form-item>
          <el-form-item label="活动日期：" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择活动日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动时间：" prop="timeRange">
            <el-time-picker
              is-range
              v-model="ruleForm.timeRange"
              value-format="HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { modelFunAdd, modelFunInfo, modelFunEdit } from '@/api/seckill'
export default {
  name: 'SeckillAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      fileList: [],
      ruleForm: {
        name: '',
        date:'',
        timeRange: ['00:00:00', '23:59:59'],
        status: false
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择活动日期', trigger: 'blur' }
        ],
        timeRange: [
          { required: true, message: '请选择时间范围', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (this.$route.query.dataId === undefined || this.$route.query.dataId === 'undefined') {
      this.dataId = ''
    } else {
      let that = this
      modelFunInfo({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.name = data.name
          that.ruleForm.date = data.secKillDate
          that.ruleForm.timeRange = [data.secKillStartTime,data.secKillEndTime]
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let name = that.ruleForm.name
      let timeRange = that.ruleForm.timeRange
      let date = that.ruleForm.date
      let status = that.ruleForm.status ? 1 : 0
      let startTime = ''
      let endTime = ''
      if (timeRange !== null) {
        startTime = that.ruleForm.timeRange[0]
        endTime = that.ruleForm.timeRange[1]
      }
      if (name === '') {
        this.$message.error('请输入活动名称')
        return false
      }
      if (date === '') {
        this.$message.error('请选择日期')
        return false
      }
      let passData = {
        name: name, secKillDate: date, secKillStartTime: startTime, secKillEndTime: endTime, status: status
      }
      if (dataId !== '') {
        passData.id = dataId;
        modelFunEdit(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        modelFunAdd(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/seckill/SeckillAdd.vue